import { render, staticRenderFns } from "./AccountActivation.vue?vue&type=template&id=0b45956d&scoped=true"
import script from "./AccountActivation.vue?vue&type=script&lang=js"
export * from "./AccountActivation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b45956d",
  null
  
)

export default component.exports